import React, { useCallback, useContext, useEffect, useRef } from "react";
import styles from "./Header.module.scss";
import { PUBLIC_ICON, PUBLIC_IMAGE } from "../../constants";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import poolsStore from "../../stores/poolsStore";
import formStore from "../../stores/formStore";
import { useMetaMask } from "../../hooks/useMetaMask";
import {
  ACCOUNT_ROUTE,
  CREDITS_ROUTE,
  EXCHANGER_ROUTE,
  POOLS_ROUTE,
  PROFILE_ROUTE,
} from "../../utils/consts";
import { Context } from "../../..";
import presaleStore from "../../stores/presaleStore";

const Header = () => {
  const mainLogoPath = PUBLIC_IMAGE + "main-logo.svg";
  const navigate = useNavigate();
  const burgerRef = useRef<HTMLDivElement>(null);
  const menuRef = useRef<HTMLDivElement>(null);
  const { user } = useContext(Context);

  const toggleMenu = useCallback(() => {
    if (document.body.style.overflowY === "hidden") {
      document.body.style.overflowY = "";
      document.documentElement.style.overflowY = "";
    } else {
      document.body.style.overflowY = "hidden";
      document.documentElement.style.overflowY = "hidden";
    }
    burgerRef.current?.classList.toggle("active");
    menuRef.current?.classList.toggle("open");
    document.body.classList.toggle("active");
  }, []);

  const closeMenu = useCallback(() => {
    document.body.style.overflowY = "";
    document.documentElement.style.overflowY = "";
    burgerRef.current?.classList.remove("active");
    menuRef.current?.classList.remove("open");
    document.body.classList.remove("active");
  }, []);

  useEffect(() => {
    if (burgerRef.current) {
      burgerRef.current.addEventListener("click", toggleMenu);
      return () => {
        burgerRef.current?.removeEventListener("click", toggleMenu);
      };
    }
  }, [toggleMenu]);

  const handleLinkClick = (route: string) => {
    closeMenu();
    navigate(route);
  };

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <div className={styles.header__inner}>
          <a href="https://alfa-crypto.com/">
            <img
              src={mainLogoPath}
              alt="mainImage"
              className={styles.header__innerLogo}
            />
          </a>
          <nav className={styles.menu}>
            <div className={styles.burger} ref={burgerRef}>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </div>
            <div className={styles.menu__listHeader} ref={menuRef}>
              <div className={styles.menu__listHeaderWrap}>
                <li className={styles.menu__listItem}>
                  <a
                    onClick={() => {
                      handleLinkClick(EXCHANGER_ROUTE);
                      formStore.setDataValid(undefined);
                      poolsStore.setIsSubscribe(undefined);
                      poolsStore.setIsConfirm(undefined);
                    }}
                    className={styles.menu__listLink}
                  >
                    AI Smart Rate
                  </a>
                </li>
                <li className={styles.menu__listItem}>
                  <a
                    onClick={() => {
                      poolsStore.setIsSubscribe(false);
                    }}
                    href="https://alfa-crypto.com/cards/"
                    className={styles.menu__listLink}
                  >
                    Cards
                  </a>
                </li>
                <li className={styles.menu__listItem}>
                  <a
                    href="https://alfa-crypto.com/coming_soon"
                    className={styles.menu__listLink}
                  >
                    Bots
                  </a>
                </li>
                <li className={styles.menu__listItem}>
                  <a
                    onClick={() => {
                      handleLinkClick(POOLS_ROUTE);
                      formStore.setDataValid(undefined);
                      poolsStore.setIsSubscribe(undefined);
                    }}
                    className={styles.menu__listLink}
                  >
                    Pools
                  </a>
                </li>
                <li className={styles.menu__listItem}>
                  <a
                    onClick={() => {
                      navigate(CREDITS_ROUTE);
                      handleLinkClick(CREDITS_ROUTE);
                      formStore.setDataValid(undefined);
                      poolsStore.setIsSubscribe(undefined);
                    }}
                    className={styles.menu__listLink}
                  >
                    Credits
                  </a>
                </li>
                <li className={styles.menu__listItem}>
                  <div className={styles.menu__listLink}>
                    <a onClick={closeMenu} href="https://alfa-crypto.com/payments/business/">
                      Payments
                    </a>
                    <div
                      className={`${styles.menu__dropdownContent} ${styles.dropdown__sheepy}`}
                    >
                      <div className={styles.menu__dropdownWrapper}>
                        <img
                          src={PUBLIC_IMAGE + "dropdown-iconImage.svg"}
                          alt=""
                        />
                        <a
                          onClick={closeMenu}
                          href="https://alfa-crypto.com/payments/business/"
                        >
                          <div className={styles.menu__dropdownTitle}>
                            Business
                          </div>
                          <div className={styles.menu__dropdownText}>
                            Accept major cryptocurrencies, manage fiat <br></br>{" "}
                            converson, keep or request payouts.
                          </div>
                        </a>
                      </div>
                      <div className={styles.menu__dropdownWrapper}>
                        <img
                          src={PUBLIC_IMAGE + "dropdown-iconImage.svg"}
                          alt=""
                        />
                        <a
                          onClick={() => handleLinkClick(EXCHANGER_ROUTE)}
                          href="https://alfa-crypto.com/fundraising"
                        >
                          <div className={styles.menu__dropdownTitle}>
                            Fundraising
                          </div>
                          <div className={styles.menu__dropdownText}>
                            Accept major cryptocurrencies, manage fiat <br></br>{" "}
                            converson, keep or request payouts.
                          </div>
                        </a>
                      </div>
                      <div className={styles.menu__dropdownWrapper}>
                        <img
                          src={PUBLIC_IMAGE + "dropdown-iconImage.svg"}
                          alt=""
                        />
                        <a
                          onClick={() => handleLinkClick(EXCHANGER_ROUTE)}
                          href="https://alfa-crypto.com/merchant"
                        >
                          <div className={styles.menu__dropdownTitle}>
                            Merchant
                          </div>
                          <div className={styles.menu__dropdownText}>
                            Send payments to multiple recipients <br></br>{" "}
                            simultaneously.
                          </div>
                        </a>
                      </div>
                      <div className={styles.menu__dropdownWrapper}>
                        <img
                          src={PUBLIC_IMAGE + "dropdown-iconImage.svg"}
                          alt=""
                        />
                        <a
                          onClick={() => handleLinkClick(EXCHANGER_ROUTE)}
                          href="https://alfa-crypto.com/demo"
                        >
                          <div className={styles.menu__dropdownTitle}>Demo</div>
                          <div className={styles.menu__dropdownText}>
                            Send payments to multiple recipients <br></br>{" "}
                            simultaneously.
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <img
                    src={PUBLIC_IMAGE + "Header-arrowImageDown.svg"}
                    alt=""
                    className={styles.menu__itemArrow}
                  />
                </li>
                <li className={styles.menu__listItem}>
                  <div className={styles.menu__listLink}>
                    <a
                      onClick={() => handleLinkClick(EXCHANGER_ROUTE)}
                      href="https://alfa-crypto.com/company"
                    >
                      Company
                    </a>
                    <div
                      className={`${styles.menu__dropdownContent} ${styles.dropdown__company}`}
                    >
                      <div className={styles.menu__dropdownWrapper}>
                        <img
                          src={PUBLIC_IMAGE + "dropdown-iconImage.svg"}
                          alt=""
                        />
                        <a href="https://alfa-crypto.com/company">
                          <div className={styles.menu__dropdownTitle}>
                            About us
                          </div>
                          <div className={styles.menu__dropdownText}></div>
                        </a>
                      </div>
                      <div className={styles.menu__dropdownWrapper}>
                        <img
                          src={PUBLIC_IMAGE + "dropdown-iconImage.svg"}
                          alt=""
                        />
                        <a
                          onClick={() =>
                            window.open(
                              "/api/v1/docs/white_paper",
                              "_blank"
                            )
                          }
                        >
                          <div className={styles.menu__dropdownTitle}>
                            White papper
                          </div>
                          <div className={styles.menu__dropdownText}>
                            Accept major cryptocurrencies, manage fiat <br></br>{" "}
                            converson, keep or request payouts.
                          </div>
                        </a>
                      </div>
                      <div className={styles.menu__dropdownWrapper}>
                        <img
                          src={PUBLIC_IMAGE + "dropdown-iconImage.svg"}
                          alt=""
                        />
                        <a
                          onClick={() => handleLinkClick(EXCHANGER_ROUTE)}
                          href="https://www.alfa-crypto.com/company#faq-content"
                        >
                          <div className={styles.menu__dropdownTitle}>FAQ</div>
                          <div className={styles.menu__dropdownText}>
                            Send payments to multiple recipients <br></br>{" "}
                            simultaneously.
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <img
                    src={PUBLIC_IMAGE + "Header-arrowImageDown.svg"}
                    alt=""
                    className={styles.menu__itemArrow}
                  />
                </li>
              </div>
              <div></div>
              <div className={styles.menu__listItemBottom}>
                <li
                  className={`${styles.menu__listItem} ${styles.menu__listItemAccount}`}
                >
                  <a
                    onClick={() => {
                      user.isAuth
                        ? handleLinkClick(PROFILE_ROUTE)
                        : handleLinkClick(ACCOUNT_ROUTE);
                      poolsStore.setIsConfirm(undefined);
                    }}
                    className={styles.menu__listLink}
                  >
                    Account
                  </a>
                </li>
                <li
                  className={
                    user.isAuth
                      ? styles.menu__listItem
                      : styles.menu__listItemNone
                  }
                >
                  <a
                    onClick={() => {
                      handleLinkClick(ACCOUNT_ROUTE);
                      poolsStore.setIsConfirm(undefined);
                      user.logout();
                    }}
                    className={styles.menu__listLink}
                  >
                    Exit
                  </a>
                </li>{" "}
                <div className={styles.menu__listItemLine}></div>
                <li className={`${styles.menu__listItem} ${styles.En}`}>
                  <a href="#" className={styles.menu__listLink}>
                    En
                  </a>
                </li>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default observer(Header);
